export type AuthApiResponse = {
  ok: boolean
  error?: string
  next?: string
  redirect?: string
  positions?: number[]
  passphrase_length?: number
  needs_setup?: boolean
  secret?: string
  otpauth?: string
  backup_codes?: string[]
  backup_codes_remaining?: number
  retry_after?: number
}

export async function postAuth(
  endpoint: string,
  body: Record<string, unknown>,
): Promise<{ ok: boolean; status: number; data: AuthApiResponse }> {
  const res = await fetch(endpoint, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  })
  const data = (await res.json()) as AuthApiResponse
  return { ok: res.ok && !!data.ok, status: res.status, data }
}

/** Same-origin redirect; normalizes legacy /app/* paths to root. */
export function safeRedirect(url: string | undefined, fallback = '/'): string {
  if (!url) return fallback
  try {
    const u = new URL(url, window.location.origin)
    if (u.origin !== window.location.origin) return fallback
    let path = u.pathname
    if (path === '/app' || path === '/app/') path = '/'
    else if (path.startsWith('/app/')) path = path.slice(4) || '/'
    return path + u.search + u.hash
  } catch {
    return fallback
  }
}

export const AUTH_ENDPOINTS = {
  emailLogin: '/api/auth/email-login',
  emailRegister: '/api/auth/email-register',
  telegramLogin: '/api/auth/telegram-login',
  telegramWebapp: '/api/auth/telegram-webapp',
  logout: '/api/auth/logout',
} as const

export const BOT_URL = import.meta.env.VITE_TELEGRAM_BOT_URL || 'https://t.me/vpn_n4rhlg_bot'
